"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryNameByAlpha3 = exports.COUNTRY_ALPHA3_CODES = exports.COUNTRIES_ALPHA3 = exports.FeatureIds = exports.DistributionPreference = exports.ShareholderStatus = exports.EntityFiStatus = exports.EntityClassificationType = exports.FatcaCrsStatus = exports.TaxIdentifierType = exports.ContactType = exports.ApprovalState = exports.ActionType = exports.Roles = exports.SharesInput = exports.SharePriceType = exports.WindowTradingType = exports.WindowType = exports.APPLICANT_DOCUMENT_MAX_PER_RECORD = exports.INVESTOR_APPLICATION_DOCUMENT_MAX_FILE_BYTES = exports.INVESTOR_APPLICATION_DOCUMENT_MAX_PER_SECTION = exports.INVITATION_LINK_EXPIRY_IN_DAYS = exports.UNKNOWN_BSB = exports.ACCOUNT_BLOCKED = exports.INVALID_PAYID = exports.PAYID_NOT_RESOLVED = exports.NPP_NOT_NPP = exports.CREDITOR_DOES_NOT_EXIST = exports.INACTIVE_ACCOUNT_ERROR = exports.TOKENISER_LOGO_WHITE_TRANSPARENT = exports.TOKENISER_LOGO_DARK_TRANSPARENT = exports.TOKENISER_ACN = exports.LIQUIDISE_ADDRESS = exports.WEBSITE_BROWSE_COMPANIES_PAGE = exports.WEBSITE_PRICING_PAGE = exports.WEBSITE_PRIVACY_POLICY = exports.WEBSITE_TERMS_OF_USE = exports.WEBSITE_BASE_URL = exports.WEBSITE_LANDING_PAGE = exports.PLATFORM_SUPPORT_EMAIL = exports.PLATFORM_LINK = exports.PLATFORM_NAME = void 0;
// Liquidise App
exports.PLATFORM_NAME = "Tokeniser";
exports.PLATFORM_LINK = "https://app.tokeniser.com/";
exports.PLATFORM_SUPPORT_EMAIL = process.env.SUPPORT_EMAIL ||
    (process.env.ENVIRONMENT_NAME === "prod" || process.env.ENVIRONMENT_NAME === "demo"
        ? "support@tokeniser.com"
        : "support+test@tokeniser.com");
// Liquidise Website
exports.WEBSITE_LANDING_PAGE = "www.tokeniser.com";
exports.WEBSITE_BASE_URL = "https://www.tokeniser.com";
exports.WEBSITE_TERMS_OF_USE = `${exports.WEBSITE_BASE_URL}/terms-and-conditions`;
exports.WEBSITE_PRIVACY_POLICY = `${exports.WEBSITE_BASE_URL}/privacy`;
exports.WEBSITE_PRICING_PAGE = `${exports.WEBSITE_BASE_URL}/registry/#pricing`;
exports.WEBSITE_BROWSE_COMPANIES_PAGE = `${exports.WEBSITE_BASE_URL}/all-deals`;
// Liquidise Business
exports.LIQUIDISE_ADDRESS = "Suite 431/5 Lime St, Sydney NSW 2000";
exports.TOKENISER_ACN = "615 843 206";
// Assets
exports.TOKENISER_LOGO_DARK_TRANSPARENT = "https://storage.googleapis.com/tokeniser-common-assets/tokeniser-dark-transparent-logo.png";
exports.TOKENISER_LOGO_WHITE_TRANSPARENT = "https://storage.googleapis.com/tokeniser-common-assets/tokeniser-white-transparent-logo.png";
// Error messages
exports.INACTIVE_ACCOUNT_ERROR = "PayID functionality is unavailable for inactive accounts. Please first set account to active using the status API";
exports.CREDITOR_DOES_NOT_EXIST = "The Payee is unable to accept a Clearing Request because the account to be credited does not exist.";
exports.NPP_NOT_NPP = "BSB is not Npp enabled";
exports.PAYID_NOT_RESOLVED = "PayId not resolved";
exports.INVALID_PAYID = "Invalid PayId";
exports.ACCOUNT_BLOCKED = "Account specified is blocked, prohibiting posting of transactions against it.";
exports.UNKNOWN_BSB = "The BSB Number is unknown to mPayments'";
exports.INVITATION_LINK_EXPIRY_IN_DAYS = "15d";
/** Investor application documents (per `documentType` section: IM, fund terms, other). */
exports.INVESTOR_APPLICATION_DOCUMENT_MAX_PER_SECTION = 5;
exports.INVESTOR_APPLICATION_DOCUMENT_MAX_FILE_BYTES = 50 * 1024 * 1024;
/** Files an applicant may attach to one application. */
exports.APPLICANT_DOCUMENT_MAX_PER_RECORD = 20;
var WindowType;
(function (WindowType) {
    WindowType["TRADING"] = "trading";
    WindowType["SELL"] = "sell";
})(WindowType || (exports.WindowType = WindowType = {}));
var WindowTradingType;
(function (WindowTradingType) {
    WindowTradingType["BUY"] = "Buy";
    WindowTradingType["SELL"] = "Sell";
    WindowTradingType["BUY_AND_SELL"] = "BuyAndSell";
})(WindowTradingType || (exports.WindowTradingType = WindowTradingType = {}));
var SharePriceType;
(function (SharePriceType) {
    SharePriceType["FIXED"] = "fixed";
    SharePriceType["VARIABLE"] = "variable";
})(SharePriceType || (exports.SharePriceType = SharePriceType = {}));
var SharesInput;
(function (SharesInput) {
    SharesInput["PERCENTAGE"] = "percentage";
    SharesInput["NUMBER"] = "number";
})(SharesInput || (exports.SharesInput = SharesInput = {}));
var Roles;
(function (Roles) {
    Roles["SUPER_ADMIN"] = "SUPER_ADMIN";
    Roles["ADMIN"] = "ADMIN";
    Roles["APPROVER"] = "APPROVER";
    Roles["SHAREHOLDER"] = "SHAREHOLDER";
    Roles["EXTERNAL_INVESTOR"] = "EXTERNAL_INVESTOR";
    Roles["CONCIERGE"] = "CONCIERGE";
    Roles["NOMINEE"] = "NOMINEE";
    Roles["DIRECTOR"] = "DIRECTOR";
    Roles["COMPANY_SECRETARY"] = "COMPANY_SECRETARY";
})(Roles || (exports.Roles = Roles = {}));
var ActionType;
(function (ActionType) {
    ActionType["ISSUE_UNITS"] = "issue_units";
    ActionType["TRANSFER_UNITS"] = "transfer_units";
    ActionType["UPDATE_UNIT_PRICE"] = "update_unit_price";
    ActionType["SEND_ANNOUNCEMENT"] = "send_announcement";
    ActionType["CONFIRM_DISTRIBUTION"] = "confirm_distribution";
    ActionType["PUBLISH_TAX_RULES"] = "publish_tax_rules";
    ActionType["UPDATE_INVESTOR_BANK_ACCOUNTS"] = "update_investor_bank_accounts";
    ActionType["UPDATE_FUND_BANK_ACCOUNTS"] = "update_fund_bank_accounts";
    ActionType["APPROVE_REDEMPTION_IN_PRINCIPLE"] = "approve_redemption_in_principle";
    ActionType["APPROVE_SUBSCRIPTION_IN_PRINCIPLE"] = "approve_subscription_in_principle";
    ActionType["UPDATE_ACCRUAL_RATE"] = "update_accrual_rate";
    ActionType["UPDATE_ACCRUAL_ROUNDING"] = "update_accrual_rounding";
})(ActionType || (exports.ActionType = ActionType = {}));
var ApprovalState;
(function (ApprovalState) {
    ApprovalState["DRAFT"] = "draft";
    ApprovalState["PENDING"] = "pending";
    ApprovalState["EXECUTED"] = "executed";
})(ApprovalState || (exports.ApprovalState = ApprovalState = {}));
/** Roles a contact holds against a company investor; a contact may hold none, one or several. */
var ContactType;
(function (ContactType) {
    ContactType["CONTROLLING_PERSON"] = "Controlling Person";
    ContactType["BENEFICIAL_OWNER"] = "Beneficial Owner";
    ContactType["DIRECTOR"] = "Director";
    ContactType["AUTHORIZED_SIGNATORY"] = "Authorized Signatory";
})(ContactType || (exports.ContactType = ContactType = {}));
var TaxIdentifierType;
(function (TaxIdentifierType) {
    TaxIdentifierType["AUSTRALIAN_TFN"] = "Australian TFN";
    TaxIdentifierType["AUSTRALIAN_ABN"] = "Australian ABN";
    TaxIdentifierType["AUSTRALIAN_ACN"] = "Australian ACN";
    TaxIdentifierType["FOREIGN_TIN"] = "Foreign TIN";
    TaxIdentifierType["US_SSN"] = "US SSN";
    TaxIdentifierType["US_ITIN"] = "US ITIN";
    TaxIdentifierType["US_EIN"] = "US EIN";
    TaxIdentifierType["FATCA_GIIN"] = "FATCA GIIN";
    TaxIdentifierType["FOREIGN_ENTITY_REGISTRATION_NUMBER"] = "Foreign entity registration number";
    TaxIdentifierType["OTHER_TAX_IDENTIFIER"] = "Other tax identifier";
    TaxIdentifierType["OTHER_REGISTRATION_IDENTIFIER"] = "Other registration identifier";
    TaxIdentifierType["NOT_PROVIDED"] = "Not provided";
})(TaxIdentifierType || (exports.TaxIdentifierType = TaxIdentifierType = {}));
var FatcaCrsStatus;
(function (FatcaCrsStatus) {
    FatcaCrsStatus["REPORTABLE"] = "Reportable";
    FatcaCrsStatus["NOT_REPORTABLE"] = "Not reportable";
    FatcaCrsStatus["NOT_ASSESSED"] = "Not assessed";
    FatcaCrsStatus["REQUIRES_REMEDIATION"] = "Requires remediation";
    FatcaCrsStatus["EXEMPT"] = "Exempt";
})(FatcaCrsStatus || (exports.FatcaCrsStatus = FatcaCrsStatus = {}));
// Mirror of the odm-sdk `EntityClassificationType` document enum — stored values MUST stay identical
// across both layers (parity test guards drift). No cross-import between the SDKs.
var EntityClassificationType;
(function (EntityClassificationType) {
    EntityClassificationType["COMPANY"] = "Company";
    EntityClassificationType["TRUST"] = "Trust";
    EntityClassificationType["SELF_MANAGED_SUPER_FUND"] = "Self Managed Super Fund";
    EntityClassificationType["PARTNERSHIP"] = "Partnership";
    EntityClassificationType["CHARITY_NOT_FOR_PROFIT"] = "Charity / Not-for-profit";
    EntityClassificationType["OTHER_ENTITY"] = "Other Entity";
})(EntityClassificationType || (exports.EntityClassificationType = EntityClassificationType = {}));
// Mirror of the odm-sdk `EntityFiStatus` document enum — stored values MUST stay identical across
// both layers (parity test guards drift). No cross-import between the SDKs.
var EntityFiStatus;
(function (EntityFiStatus) {
    EntityFiStatus["FI_REPORTING"] = "FI \u2013 Reporting";
    EntityFiStatus["FI_NON_REPORTING_EXEMPT"] = "FI \u2013 Non-Reporting / Exempt";
    EntityFiStatus["FI_NON_PARTICIPATING_FFI"] = "FI \u2013 Non-Participating FFI";
    EntityFiStatus["NFE_ACTIVE"] = "NFE/NFFE \u2013 Active";
    EntityFiStatus["NFE_PASSIVE"] = "NFE/NFFE \u2013 Passive";
    EntityFiStatus["NFFE_DIRECT_REPORTING"] = "NFFE \u2013 Direct Reporting";
    EntityFiStatus["EXEMPT_BENEFICIAL_OWNER"] = "Exempt Beneficial Owner";
})(EntityFiStatus || (exports.EntityFiStatus = EntityFiStatus = {}));
var ShareholderStatus;
(function (ShareholderStatus) {
    ShareholderStatus["ACCEPTED"] = "Accepted";
    ShareholderStatus["DECLINED"] = "Declined";
    ShareholderStatus["PENDING"] = "Pending";
})(ShareholderStatus || (exports.ShareholderStatus = ShareholderStatus = {}));
var DistributionPreference;
(function (DistributionPreference) {
    DistributionPreference["payout"] = "payout";
    DistributionPreference["reinvest"] = "reinvest";
})(DistributionPreference || (exports.DistributionPreference = DistributionPreference = {}));
var FeatureIds;
(function (FeatureIds) {
    FeatureIds["ADD_INVESTORS"] = "add-investors";
    FeatureIds["ADMIN_INVESTORS_LIST_PAGE"] = "admin-investors-list-page";
    FeatureIds["ACTIVITY_NOTIFICATIONS"] = "activity-notifications";
    FeatureIds["ALLOW_IMPORT_HISTORY"] = "allow-import-history";
    FeatureIds["ALLOW_OWNER_ID_HEALING"] = "allow-owner-id-healing";
    FeatureIds["IMPORT_ADDITIONAL_CONTACTS"] = "import-additional-contacts";
    FeatureIds["IMPORT_CONTACT_KYC"] = "import-contact-kyc";
    FeatureIds["INTERNATIONAL_BANK_ACCOUNTS"] = "international-bank-accounts";
    FeatureIds["API_MANAGEMENT"] = "api-management";
    FeatureIds["APPROVALS"] = "approvals";
    FeatureIds["BGL360_FEATURE"] = "bgl360-feature";
    FeatureIds["COMBINE_484S"] = "combine-484s";
    FeatureIds["CONTACTS_READ_ONLY"] = "contacts-read-only";
    FeatureIds["DISTRIBUTIONS"] = "distributions";
    FeatureIds["ENABLE_OWNER_CONTACTS"] = "enable-owner-contacts";
    FeatureIds["ERC7540_VAULT"] = "erc7540-vault";
    FeatureIds["FATCA_CRS"] = "fatca-crs";
    FeatureIds["FUNDRAISE_FEATURES"] = "fundraise-features";
    FeatureIds["HIDE_TRADING_SELL_BUTTON"] = "hide-trading-sell-button";
    FeatureIds["NON_CUSTODIAL_WALLET_ENABLED"] = "non-custodial-wallet-enabled";
    FeatureIds["PDTI_FULL"] = "pdti-full";
    FeatureIds["REDEMPTIONS"] = "redemptions";
    FeatureIds["SHARE_CERTIFICATE_DOWNLOAD"] = "share-certificate-download";
    FeatureIds["SUBSCRIPTION_AGREEMENTS_FEATURE"] = "subscription-agreements-feature";
    FeatureIds["TOKEN_CONFIGURATION_ENABLED"] = "token-configuration-enabled";
    FeatureIds["TOKENISATION_FEATURE"] = "tokenisation-feature";
    FeatureIds["TRUST_SMSF_REDESIGN"] = "trust-smsf-redesign";
    FeatureIds["USE_INVESTOR_APPLICATION_UPDATES"] = "use-investor-application-updates";
    FeatureIds["USE_NEW_SUBSCRIPTION_MODEL"] = "use-new-subscription-model";
    FeatureIds["USE_YIELD_ACCRUAL"] = "use-yield-accrual";
})(FeatureIds || (exports.FeatureIds = FeatureIds = {}));
/** ISO 3166-1 alpha-3 country codes with display names for fund tax residency. */
exports.COUNTRIES_ALPHA3 = [
    { code: "AFG", name: "Afghanistan" },
    { code: "ALB", name: "Albania" },
    { code: "DZA", name: "Algeria" },
    { code: "AND", name: "Andorra" },
    { code: "AGO", name: "Angola" },
    { code: "ARG", name: "Argentina" },
    { code: "ARM", name: "Armenia" },
    { code: "AUS", name: "Australia" },
    { code: "AUT", name: "Austria" },
    { code: "AZE", name: "Azerbaijan" },
    { code: "BHS", name: "Bahamas" },
    { code: "BHR", name: "Bahrain" },
    { code: "BGD", name: "Bangladesh" },
    { code: "BRB", name: "Barbados" },
    { code: "BLR", name: "Belarus" },
    { code: "BEL", name: "Belgium" },
    { code: "BLZ", name: "Belize" },
    { code: "BEN", name: "Benin" },
    { code: "BTN", name: "Bhutan" },
    { code: "BOL", name: "Bolivia" },
    { code: "BIH", name: "Bosnia and Herzegovina" },
    { code: "BWA", name: "Botswana" },
    { code: "BRA", name: "Brazil" },
    { code: "BRN", name: "Brunei" },
    { code: "BGR", name: "Bulgaria" },
    { code: "BFA", name: "Burkina Faso" },
    { code: "BDI", name: "Burundi" },
    { code: "KHM", name: "Cambodia" },
    { code: "CMR", name: "Cameroon" },
    { code: "CAN", name: "Canada" },
    { code: "CPV", name: "Cape Verde" },
    { code: "CAF", name: "Central African Republic" },
    { code: "TCD", name: "Chad" },
    { code: "CHL", name: "Chile" },
    { code: "CHN", name: "China" },
    { code: "COL", name: "Colombia" },
    { code: "COM", name: "Comoros" },
    { code: "COG", name: "Congo" },
    { code: "COD", name: "Congo (Democratic Republic)" },
    { code: "CRI", name: "Costa Rica" },
    { code: "HRV", name: "Croatia" },
    { code: "CUB", name: "Cuba" },
    { code: "CYP", name: "Cyprus" },
    { code: "CZE", name: "Czech Republic" },
    { code: "DNK", name: "Denmark" },
    { code: "DJI", name: "Djibouti" },
    { code: "DOM", name: "Dominican Republic" },
    { code: "ECU", name: "Ecuador" },
    { code: "EGY", name: "Egypt" },
    { code: "SLV", name: "El Salvador" },
    { code: "GNQ", name: "Equatorial Guinea" },
    { code: "ERI", name: "Eritrea" },
    { code: "EST", name: "Estonia" },
    { code: "ETH", name: "Ethiopia" },
    { code: "FJI", name: "Fiji" },
    { code: "FIN", name: "Finland" },
    { code: "FRA", name: "France" },
    { code: "GAB", name: "Gabon" },
    { code: "GMB", name: "Gambia" },
    { code: "GEO", name: "Georgia" },
    { code: "DEU", name: "Germany" },
    { code: "GHA", name: "Ghana" },
    { code: "GRC", name: "Greece" },
    { code: "GTM", name: "Guatemala" },
    { code: "GIN", name: "Guinea" },
    { code: "GNB", name: "Guinea-Bissau" },
    { code: "GUY", name: "Guyana" },
    { code: "HTI", name: "Haiti" },
    { code: "HND", name: "Honduras" },
    { code: "HKG", name: "Hong Kong" },
    { code: "HUN", name: "Hungary" },
    { code: "ISL", name: "Iceland" },
    { code: "IND", name: "India" },
    { code: "IDN", name: "Indonesia" },
    { code: "IRN", name: "Iran" },
    { code: "IRQ", name: "Iraq" },
    { code: "IRL", name: "Ireland" },
    { code: "ISR", name: "Israel" },
    { code: "ITA", name: "Italy" },
    { code: "JAM", name: "Jamaica" },
    { code: "JPN", name: "Japan" },
    { code: "JOR", name: "Jordan" },
    { code: "KAZ", name: "Kazakhstan" },
    { code: "KEN", name: "Kenya" },
    { code: "KWT", name: "Kuwait" },
    { code: "KGZ", name: "Kyrgyzstan" },
    { code: "LAO", name: "Laos" },
    { code: "LVA", name: "Latvia" },
    { code: "LBN", name: "Lebanon" },
    { code: "LBY", name: "Libya" },
    { code: "LIE", name: "Liechtenstein" },
    { code: "LTU", name: "Lithuania" },
    { code: "LUX", name: "Luxembourg" },
    { code: "MAC", name: "Macau" },
    { code: "MKD", name: "Macedonia" },
    { code: "MDG", name: "Madagascar" },
    { code: "MWI", name: "Malawi" },
    { code: "MYS", name: "Malaysia" },
    { code: "MDV", name: "Maldives" },
    { code: "MLI", name: "Mali" },
    { code: "MLT", name: "Malta" },
    { code: "MRT", name: "Mauritania" },
    { code: "MUS", name: "Mauritius" },
    { code: "MEX", name: "Mexico" },
    { code: "MDA", name: "Moldova" },
    { code: "MCO", name: "Monaco" },
    { code: "MNG", name: "Mongolia" },
    { code: "MNE", name: "Montenegro" },
    { code: "MAR", name: "Morocco" },
    { code: "MOZ", name: "Mozambique" },
    { code: "MMR", name: "Myanmar" },
    { code: "NAM", name: "Namibia" },
    { code: "NPL", name: "Nepal" },
    { code: "NLD", name: "Netherlands" },
    { code: "NZL", name: "New Zealand" },
    { code: "NIC", name: "Nicaragua" },
    { code: "NER", name: "Niger" },
    { code: "NGA", name: "Nigeria" },
    { code: "NOR", name: "Norway" },
    { code: "OMN", name: "Oman" },
    { code: "PAK", name: "Pakistan" },
    { code: "PAN", name: "Panama" },
    { code: "PNG", name: "Papua New Guinea" },
    { code: "PRY", name: "Paraguay" },
    { code: "PER", name: "Peru" },
    { code: "PHL", name: "Philippines" },
    { code: "POL", name: "Poland" },
    { code: "PRT", name: "Portugal" },
    { code: "QAT", name: "Qatar" },
    { code: "ROU", name: "Romania" },
    { code: "RUS", name: "Russia" },
    { code: "RWA", name: "Rwanda" },
    { code: "SAU", name: "Saudi Arabia" },
    { code: "SEN", name: "Senegal" },
    { code: "SRB", name: "Serbia" },
    { code: "SGP", name: "Singapore" },
    { code: "SVK", name: "Slovakia" },
    { code: "SVN", name: "Slovenia" },
    { code: "SOM", name: "Somalia" },
    { code: "ZAF", name: "South Africa" },
    { code: "KOR", name: "South Korea" },
    { code: "SSD", name: "South Sudan" },
    { code: "ESP", name: "Spain" },
    { code: "LKA", name: "Sri Lanka" },
    { code: "SDN", name: "Sudan" },
    { code: "SUR", name: "Suriname" },
    { code: "SWE", name: "Sweden" },
    { code: "CHE", name: "Switzerland" },
    { code: "SYR", name: "Syria" },
    { code: "TWN", name: "Taiwan" },
    { code: "TJK", name: "Tajikistan" },
    { code: "TZA", name: "Tanzania" },
    { code: "THA", name: "Thailand" },
    { code: "TGO", name: "Togo" },
    { code: "TTO", name: "Trinidad and Tobago" },
    { code: "TUN", name: "Tunisia" },
    { code: "TUR", name: "Turkey" },
    { code: "TKM", name: "Turkmenistan" },
    { code: "UGA", name: "Uganda" },
    { code: "UKR", name: "Ukraine" },
    { code: "ARE", name: "United Arab Emirates" },
    { code: "GBR", name: "United Kingdom" },
    { code: "USA", name: "United States" },
    { code: "URY", name: "Uruguay" },
    { code: "UZB", name: "Uzbekistan" },
    { code: "VEN", name: "Venezuela" },
    { code: "VNM", name: "Vietnam" },
    { code: "YEM", name: "Yemen" },
    { code: "ZMB", name: "Zambia" },
    { code: "ZWE", name: "Zimbabwe" },
];
exports.COUNTRY_ALPHA3_CODES = new Set(exports.COUNTRIES_ALPHA3.map((country) => country.code));
const getCountryNameByAlpha3 = (code) => exports.COUNTRIES_ALPHA3.find((country) => country.code === code)?.name;
exports.getCountryNameByAlpha3 = getCountryNameByAlpha3;
//# sourceMappingURL=constants.js.map